import { EMPTY_STRING, ZERO } from "../constants";
const STRING = "string";
const OBJECT = "object";
const ARRAY = "array";

const convertDictToList = (data, level = EMPTY_STRING) => {
  const result = [];
  for (const key in data) {
    const value = data[key];
    const newLevel = level ? `${level}.${key}` : key;
    if (typeof value === OBJECT) {
      if (Array.isArray(value)) {
        const isString = typeof value[ZERO] === STRING;
        result.push({
          name: key,
          type: ARRAY,
          level: `${newLevel}`,
          body: isString ? [] : convertDictToList(value[ZERO], `${newLevel}[]`),
        });
      } else {
        result.push({
          name: key,
          type: OBJECT,
          level: newLevel,
          body: convertDictToList(value, newLevel),
        });
      }
    } else {
      result.push({
        name: key,
        type: typeof value,
        level: newLevel,
        body: [],
      });
    }
  }
  return result;
};

export default convertDictToList;
